import { from, Observable, of, throwError, Subject } from 'rxjs';
import { catchError, map, mergeMap, take, debounceTime } from 'rxjs/operators';
import { LoggerTransport, LogMessage } from '../logger.model';

export class HttpTransport implements LoggerTransport {
  private readonly serverFlushTime = 5000;

  private logMessages: LogMessage[] = [];
  private flushEvents$: Subject<void> = new Subject();

  constructor(private options: any) {
    this.flushEvents$.pipe(debounceTime(this.serverFlushTime)).subscribe(() => this.postLogMessages());
  }

  sendMessage(message: LogMessage) {
    this.logMessages.push(message);
    this.flushEvents$.next();
  }

  postLogMessages() {
    const url = this.options.url;
    if (!!!url) {
      console.error('"url" is not configured for http log transport.');
      return;
    }

    const messages = [...this.logMessages];

    this.logMessages = [];

    const bodyData = this.buildLogMessagePostRequest(messages);
    const body = JSON.stringify(bodyData);

    from(
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body
      })
    )
      .pipe(
        mergeMap(response => {
          if (response.status === 200) {
            return from(response.text());
          } else {
            throw new Error(response.statusText);
          }
        }),
        map(res => {
          try {
            return JSON.parse(res);
          } catch (e) {
            return res;
          }
        }),
        catchError(err => this.handleError(err))
      )
      .subscribe();
  }

  buildLogMessagePostRequest(messages: LogMessage[]): any[] {
    const body = messages.map(m => {
      return {
        timestamp: m.timestamp,
        message: m.message,
        logLevel: m.level,
        data: !!m.data ? JSON.stringify(m.data) : null,
        context: !!m.context ? JSON.stringify(m.context) : null
      };
    });

    return body;
  }

  handleError(err): Observable<never> {
    console.error(err);
    return;
  }
}
